import '../step.scss';
import 'sass/form/_form.scss';
import 'sass/_block-waiting-holders.scss';

//@vendors
import React from 'react';
import { connect } from 'react-redux';
//@actions
import { actions as formActions, Form } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { history } from 'routes/history';
import stepsActions from 'actions/stepsActions';
import optionsActions from 'actions/optionsActions';
import focusActions from 'actions/focusActions';
import preLoaderActions from 'actions/preLoaderActions';
import jointHoldersStatusActions from 'actions/jointHoldersStatusActions';
import createActions from 'actions/createActions';
import accountTypeActions from 'actions/accountTypeActions';
import standByActions from 'actions/standByActions';
import scoringActions from 'actions/scoringActions';
import { stopPolling } from 'actions/polling';
//@components
import { AccountType } from 'components/accountType';
import RadioButton from 'components/radioButton/radioButton';
import { RoadmapNavigation } from 'components/steps/roadmapNavigation';
import Disclaimer from 'components/containers/disclaimer';
import Headline from 'components/headline';
import { StandByHC } from 'components/newAccountSteps/profileSteps/standByHC';
// @ HOCs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
//@utilities
import { formatText } from 'core/i18n';
import scroll from 'utilities/scroll';
import { clickTaleEnd, clickTaleStart } from 'utilities/clickTale';
import { mustContinueToStep3 } from 'utilities/logicByCountry';
import { accountTypeModel } from 'utilities/professionHelper';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { checkIfInputIsVisibleByPartialId } from 'utilities/tools';
// @constants
import { FIOC_TGSS, NEW_OPTIONS_OPERATIONS, ONBOARDING_FLAG_WEB_FIOC_RESPONSE_NO_ACT } from 'constants/featureFlagging';
import { INVEST_PROFILE } from 'constants/uTagConstants/RAConstants';
import { DEBIT_CARD } from 'constants/statusProcess';
import { CREDIT_CARD, GBI, ROBO } from 'constants/userProfile';
import { CIRBE } from 'constants/identityMethod';
import { BANK_AND_TRAVEL_CHECKS_MOVEMENTS, CRYPTO_CURRENCY_MOVEMENTS } from 'constants/fioc';
import { BASE_PATH } from 'constants';
import modalCancelActions from 'actions/modalCancelActions';
import consentsActions from 'actions/consentsActions';
import jointHoldersActions from 'actions/jointHoldersActions';
import { createClientWithConsent } from 'components/newAccountSteps/profileSteps/services/createClientWithConsent';
import { FUNDS_ORIGINS_USER_PROFILE_KEYS } from 'components/FundsOriginDeclaration/constants';
import { getFundsOriginsCheckedStatus } from '../../../FundsOriginDeclaration/getFundsOriginsCheckedStatus';
import buildTagging from './tagging';

const TRUE_RADIO = '1';

const validationsList = {
    capitalCombo: [
        'is_patrimony',
        'capital_work',
        'capital_activities',
        'capital_heritage',
        'capital_business',
        'capital_realState',
        'capital_gamesOfChance',
        'capital_other',
    ],
    accountUseCombo: {
        basicCombo: [
            'highOperativeWithRiskCountries',
            'deliveryOrCashWithdrawals',
            'buyingAndSellingForeingBanknotes',
            'paymentOrdersOrCollectionAbroad',
            'foreingTradeOperations',
            'noneOfTheAbove',
        ],
        flagDependency: {
            [NEW_OPTIONS_OPERATIONS]: {
                on: [BANK_AND_TRAVEL_CHECKS_MOVEMENTS, CRYPTO_CURRENCY_MOVEMENTS],
                off: ['buyingSellingBearerPaymentMethods', 'frequentTravelChecksMovements'],
            },
        },
    },
    incomeCombo: ['income_work', 'income_activities', 'income_business', 'income_realState', 'income_other'],
    selfEmployed: {
        primaries: [
            'selfEmployed_company',
            'selfEmployed_publicCharges',
            'selfEmployed_accountMoney',
            'selfEmployed_accountUse',
            'selfEmployed_annualIncomeAmount',
            'profession_cnae_answer',
            'is_patrimony',
            'profession_id',
            'taxation',
        ],
        primariesTC: [
            'selfEmployed_company',
            'selfEmployed_annualIncomeAmount',
            'profession_id',
            'profession_cnae_answer',
        ],
        dependences: {
            selfEmployed_hasPEP: ['selfEmployed_publicCharges_details'],
            selfEmployed_accountUse: ['selfEmployed_accountUse_list', 'is_income'],
            selfEmployed_usage: ['is_patrimony', 'is_income'],
            selfEmployed_usage_patrimony: ['is_patrimony'],
        },
    },
    employed: {
        primaries: [
            'profession_option',
            'employed_company',
            'employed_hasPEP',
            'employed_accountUse',
            'employed_accountMoney',
            'employed_annualIncomeAmount',
            'is_patrimony',
            'taxation',
            'cno2_profession_id',
        ],
        primariesTC: ['profession_option', 'employed_company', 'employed_annualIncomeAmount', 'cno2_profession_id'],
        dependences: {
            employed_hasPEP: ['employed_hasPEP_details', 'is_income'],
            employed_accountUse: ['employed_accountUse_list'],
            employed_usage: ['is_patrimony', 'is_income'],
        },
    },
    rentier: {
        primaries: [
            'rentier_hasPEP',
            'rentier_accountMoney',
            'rentier_accountUse',
            'rentier_annualIncomeAmount',
            'is_patrimony',
            'is_income',
            'taxation',
        ],
        primariesTC: ['rentier_annualIncomeAmount'],
        dependences: {
            rentier_hasPEP: ['rentier_hasPEP_details'],
            rentier_accountUse: ['rentier_accountUse_list'],
        },
    },
    pensioner: {
        primaries: [
            'pensioner_hasPEP',
            'pensioner_accountMoney',
            'pensioner_accountUse',
            'pensioner_annualIncomeAmount',
            'is_patrimony',
            'taxation',
        ],
        primariesTC: ['pensioner_annualIncomeAmount'],
        dependences: {
            pensioner_hasPEP: ['pensioner_hasPEP_details', 'is_income'],
            pensioner_usage: ['is_patrimony', 'is_income'],
            pensioner_accountUse: ['pensioner_accountUse_list'],
        },
    },
    withoutActivity: {
        primaries: [
            'withoutActivity_activity',
            'withoutActivity_hasPEP',
            'withoutActivity_accountMoney',
            'withoutActivity_accountUse',
            'is_patrimony',
            'is_fundsOrigin',
            'taxation',
        ],
        primariesTC: ['withoutActivity_activity'],
        dependences: {
            withoutActivity_hasPEP: ['withoutActivity_hasPEP_details'],
            withoutActivity_usage: ['is_patrimony'],
            withoutActivity_accountUse: ['withoutActivity_accountUse_list'],
        },
    },
};

class ProfileStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.tagging = buildTagging({ userProfile: this.props.userProfile, products: this.props.products });
        this.state = {
            isLoadingTypeOfAccounts: true,
            showModalNonExclusiveKO: false,
            blowupClass: 'blowup-modal blowup-in',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeFieldWorkBy = this.handleChangeFieldWorkBy.bind(this);
        this.formValidations = validationsList;
        this.getCountries = this.getCountries.bind(this);
        this.getWorkFor = this.getWorkFor.bind(this);
        this.onHandleValidateFields = this.onHandleValidateFields.bind(this);
        this.handleResetFields = this.handleResetFields.bind(this);
        this.buildModalNonExclusiveKO = this.buildModalNonExclusiveKO.bind(this);
        this.handleShowNonExclusiveModal = this.handleShowNonExclusiveModal.bind(this);
        this.handleHideNonExclusiveModal = this.handleHideNonExclusiveModal.bind(this);
        this.typeOfAccounts = [];
        this.saveFiocData = this.saveFiocData.bind(this);
        this.saveSelfEmployed = this.saveSelfEmployed.bind(this);
        this.saveEmployed = this.saveEmployed.bind(this);
        this.saveRentier = this.saveRentier.bind(this);
        this.savePensioner = this.savePensioner.bind(this);
        this.saveWithoutActivity = this.saveWithoutActivity.bind(this);
        this.fillCapital = this.fillCapital.bind(this);
        this.fillIncomes = this.fillIncomes.bind(this);
        this.fillPublicCharges = this.fillPublicCharges.bind(this);
        this.fillOperations = this.fillOperations.bind(this);
        this.fillPurpose = this.fillPurpose.bind(this);
        this.fillTaxation = this.fillTaxation.bind(this);
        this.handleBlowupClass = this.handleBlowupClass.bind(this);
        this.getRequiredFields = this.getRequiredFields.bind(this);
        this.createClient = this.createClient.bind(this);
        this.clientFiocAlta = this.clientFiocAlta.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { options, optionsActions } = this.props;

        if (options.get('countries').size == 0) {
            optionsActions.getCountries();
        }

        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { jointHoldersStatusActions, userProfile, immStepsState } = this.props;
        const { doTagRecordPage, doTagRecordRAPage } = this.tagging;
        const accessToken = userProfile.accessToken;
        if (userProfile.status !== 'waiting') {
            !immStepsState.get('welcomeCard') && doTagRecordPage();
        }

        if (userProfile.status === 'waiting') {
            jointHoldersStatusActions.statusHolders(accessToken);
        }
        clickTaleStart();
        const { investmentType } = userProfile;
        if (investmentType === ROBO || investmentType === GBI) {
            const { immCustomPlanByObjective, immManagementPlan, immSimulation } = this.props;

            let investProfile;
            let objective;

            switch (investmentType) {
                case ROBO:
                    investProfile =
                        INVEST_PROFILE[immManagementPlan.get('investProfileValue')] ||
                        immSimulation.get('selectedPortfolio') ||
                        '';
                    objective = '';
                    break;
                case GBI:
                    investProfile = INVEST_PROFILE[immCustomPlanByObjective.get('selectedStrategy')] || '';
                    objective = immCustomPlanByObjective.get('objectiveType');
                    break;
                default:
                    investProfile = '';
                    objective = '';
                    break;
            }
            doTagRecordRAPage({ investProfile, objective });
        }
    }

    componentDidUpdate() {
        const { userProfileForm } = this.props;

        if (!userProfileForm.$form.valid && this.props.focus.get('triggerValidations')) {
            const errosElements = document.getElementsByClassName('valid-error');
            if (errosElements.length > 0) {
                const isCheckBox = errosElements[0].classList.contains('form__check-list');

                const input = isCheckBox
                    ? errosElements[0]
                    : errosElements[0].getElementsByTagName('input')[0] ||
                      errosElements[0].getElementsByClassName('Select-control')[0];

                if (input) {
                    scroll.transition(input);
                } else {
                    this.props.focusActions.setFocusForm(errosElements[0].id);
                }
            }
            this.props.focusActions.triggerValidations(false);
        }
    }

    componentWillUnmount() {
        const { formActions } = this.props;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        let requiredFields;

        if (!disabled) {
            requiredFields = this.getRequiredFields();
            for (let i = 0; i < requiredFields.length; i++) {
                formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: true });
            }
        }
        clickTaleEnd();
        stopPolling();
    }

    getWorkFor() {
        const workFor = [
            { value: '02', label: formatText('informationText-workFor02') },
            { value: '01', label: formatText('informationText-workFor01') },
            { value: '03', label: formatText('informationText-workFor03') },
            { value: '04', label: formatText('informationText-workFor04') },
            { value: '05', label: formatText('informationText-workFor05') },
        ];

        return workFor;
    }

    /*
     * Function that fill data into input select nationality
     */
    getCountries() {
        const countries = [];
        this.props.options.get('countries').map(function (value) {
            countries.push(value.toObject());
        });

        return countries;
    }

    removeValidations(arrayValidations) {
        const { formActions } = this.props;
        for (let i = 0; i < arrayValidations.length; i++) {
            formActions.setValidity(`userProfile.${arrayValidations[i]}`, { required: true });
        }
    }

    insertCirbeFieldsIfRequired = requiredFields => {
        const { userProfile, flags } = this.props;
        if (flags.get(CIRBE) && userProfile.investmentType === CREDIT_CARD) {
            requiredFields = requiredFields.concat([
                'monthlyAmount',
                'monthlyRenting',
                'monthlyMortgage',
                'monthlyLoan',
                'cirbeConsent',
                'cirbeConsentCheck',
            ]);

            if (userProfile.monthlyRenting === TRUE_RADIO)
                requiredFields = requiredFields.concat(['monthlyRentingAmount']);
            if (userProfile.monthlyMortgage === TRUE_RADIO)
                requiredFields = requiredFields.concat(['monthlyMortgageAmount']);
            if (userProfile.monthlyLoan === TRUE_RADIO) requiredFields = requiredFields.concat(['monthlyLoanAmount']);
        }

        return requiredFields;
    };

    getRequiredFields() {
        const { userProfile, formActions } = this.props;
        const accountId = userProfile.accountType ? userProfile.accountType : 0;
        let requiredFields = {};
        const tc = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType)[CREDIT_CARD] ? 'TC' : '';

        switch (accountId) {
            case '01':
                requiredFields = this.formValidations.selfEmployed[`primaries${tc}`];
                requiredFields = this.insertCirbeFieldsIfRequired(requiredFields);

                // Dynamic validations
                if (userProfile.profession_cnae_answer === 'No') {
                    requiredFields = requiredFields.concat(['profession_category']);
                } else {
                    this.removeValidations(['profession_category']);
                }

                if (userProfile.selfEmployed_publicCharges === 'true') {
                    requiredFields = requiredFields.concat(
                        this.formValidations.selfEmployed.dependences.selfEmployed_hasPEP
                    );
                } else {
                    this.removeValidations(this.formValidations.selfEmployed.dependences.selfEmployed_hasPEP);
                }
                if (
                    userProfile.selfEmployed_accountUse === 'professional' ||
                    userProfile.selfEmployed_accountUse === 'other'
                ) {
                    requiredFields = requiredFields.concat(
                        this.formValidations.selfEmployed.dependences.selfEmployed_accountUse
                    );
                    if (
                        userProfile.selfEmployed_publicCharges === 'false' ||
                        typeof userProfile.selfEmployed_publicCharges === 'undefined'
                    ) {
                        requiredFields = requiredFields.concat(
                            this.formValidations.selfEmployed.dependences.selfEmployed_usage_patrimony
                        );
                    } else {
                        this.removeValidations(this.formValidations.selfEmployed.dependences.selfEmployed_usage);
                    }
                } else {
                    this.removeValidations(['selfEmployed_accountUse_list']);
                }
                break;
            case '02':
                requiredFields = this.formValidations.employed[`primaries${tc}`];
                requiredFields = this.insertCirbeFieldsIfRequired(requiredFields);

                // Dynamic validations
                if (userProfile.profession_option) {
                    if (userProfile.profession_option === '1') {
                        requiredFields = requiredFields.concat(['cno1_profession_id']);
                        if (userProfile.cno1_profession_id === '-1') {
                            formActions.change('userProfile.cno1_profession_id', '');
                        }
                    } else {
                        this.removeValidations(['cno1_profession_id']);
                    }
                    if (userProfile.profession_option === '2') {
                        if (userProfile.cno2_profession_id === '-1') {
                            formActions.change('userProfile.cno2_profession_id', '');
                        }
                        requiredFields = requiredFields.concat(['profession_category']);
                        requiredFields = requiredFields.concat(['cno2_profession_id']);
                    } else {
                        this.removeValidations(['cno2_profession_id', 'profession_category']);
                    }
                }

                if (userProfile.employed_hasPEP === 'true') {
                    requiredFields = requiredFields.concat(this.formValidations.employed.dependences.employed_hasPEP);
                } else {
                    this.removeValidations(this.formValidations.employed.dependences.employed_hasPEP);
                }
                // other
                if (userProfile.employed_accountUse === 'other') {
                    requiredFields = requiredFields.concat(['employed_accountUse_list']);
                    if (userProfile.employed_hasPEP === 'false' || typeof userProfile.employed_hasPEP === 'undefined') {
                        requiredFields = requiredFields.concat(
                            this.formValidations.employed.dependences.employed_usage
                        );
                    } else {
                        this.removeValidations(this.formValidations.employed.dependences.employed_usage);
                    }
                } else {
                    this.removeValidations(['employed_accountUse_list']);
                }
                break;
            case '03': // Rentier
                requiredFields = this.formValidations.rentier[`primaries${tc}`];
                requiredFields = this.insertCirbeFieldsIfRequired(requiredFields);
                // Dynamic validations
                if (userProfile.rentier_hasPEP === 'true') {
                    requiredFields = requiredFields.concat(this.formValidations.rentier.dependences.rentier_hasPEP);
                } else {
                    this.removeValidations(this.formValidations.rentier.dependences.rentier_hasPEP);
                }

                if (userProfile.rentier_accountUse === 'other') {
                    requiredFields = requiredFields.concat(['rentier_accountUse_list']);
                } else {
                    this.removeValidations(['rentier_accountUse_list']);
                }
                break;
            case '04':
                requiredFields = this.formValidations.pensioner[`primaries${tc}`];
                requiredFields = this.insertCirbeFieldsIfRequired(requiredFields);
                // Dynamic validations
                if (userProfile.pensioner_hasPEP === 'true') {
                    requiredFields = requiredFields.concat(this.formValidations.pensioner.dependences.pensioner_hasPEP);
                } else {
                    this.removeValidations(this.formValidations.pensioner.dependences.pensioner_hasPEP);
                }

                if (userProfile.pensioner_accountUse === 'other') {
                    requiredFields = requiredFields.concat(['pensioner_accountUse_list']);
                    if (
                        userProfile.pensioner_hasPEP === 'false' ||
                        typeof userProfile.pensioner_hasPEP === 'undefined'
                    ) {
                        requiredFields = requiredFields.concat(
                            this.formValidations.pensioner.dependences.pensioner_usage
                        );
                    } else {
                        this.removeValidations(this.formValidations.pensioner.dependences.pensioner_usage);
                    }
                } else {
                    this.removeValidations(['pensioner_accountUse_list']);
                }
                break;
            case '05':
                requiredFields = this.formValidations.withoutActivity[`primaries${tc}`];
                // Dynamic validations
                if (userProfile.withoutActivity_hasPEP === 'true') {
                    requiredFields = requiredFields.concat(
                        this.formValidations.withoutActivity.dependences.withoutActivity_hasPEP
                    );
                } else {
                    this.removeValidations(this.formValidations.withoutActivity.dependences.withoutActivity_hasPEP);
                }

                if (userProfile.withoutActivity_accountUse === 'other') {
                    requiredFields = requiredFields.concat(['withoutActivity_accountUse_list']);
                    if (
                        userProfile.withoutActivity_hasPEP === 'false' ||
                        typeof userProfile.withoutActivity_hasPEP === 'undefined'
                    ) {
                        requiredFields = requiredFields.concat(
                            this.formValidations.withoutActivity.dependences.withoutActivity_usage
                        );
                    } else {
                        this.removeValidations(this.formValidations.withoutActivity.dependences.withoutActivity_usage);
                    }
                } else {
                    this.removeValidations(['withoutActivity_accountUse_list']);
                }
                break;
            default:
                requiredFields = this.formValidations.employed[`primaries${tc}`];
                break;
        }

        // Common validations
        if (userProfile.income_other) {
            requiredFields = requiredFields.concat(['income_description']);
        } else {
            this.removeValidations(['income_description']);
        }

        if (userProfile.capital_other) {
            requiredFields = requiredFields.concat(['capital_description']);
        } else {
            this.removeValidations(['capital_description']);
        }

        if (userProfile.taxation === 'true') {
            userProfile.taxationCounter.map(value => {
                if (typeof value !== 'undefined') {
                    requiredFields = requiredFields.concat([
                        `taxation_country_${value}`,
                        `taxation_reason_${value}`,
                        `taxation_tin_code_${value}`,
                    ]);
                }
            });
        } else if (typeof userProfile.taxationCounter !== 'undefined') {
            userProfile.taxationCounter.map(value => {
                this.removeValidations([
                    `taxation_country_${value}`,
                    `taxation_reason_${value}`,
                    `taxation_tin_code_${value}`,
                ]);
            });
        }

        return requiredFields;
    }

    validateComboList = ({ basicCombo, flagDependency, flag }) => {
        const { userProfile, formActions, flags } = this.props;
        const comboKeys = basicCombo;

        if (flag) {
            const isFlagEnabled = flags.get(flag);
            const optionsToConcat = isFlagEnabled ? flagDependency[flag].on : flagDependency[flag].off;
            comboKeys.push(...optionsToConcat);
        }

        const areAllCombosUnchecked = comboKeys.every(check => !userProfile[check]);

        areAllCombosUnchecked &&
            comboKeys.forEach(key => {
                const isCheckListVisible = checkIfInputIsVisibleByPartialId(key);
                if (!isCheckListVisible) return;

                formActions.setValidity(`userProfile.${key}`, { required: false });
            });
    };

    handleCancel = () => {
        const { doTagCancel } = this.tagging;
        doTagCancel();

        this.props.modalCancelActions.showModalCancel();
    };

    onHandleValidateFields() {
        const { doTagValidateFields, doTagErrorValidateFields } = this.tagging;
        doTagValidateFields();

        const { userProfile, formActions } = this.props;
        const { investmentType } = userProfile;

        let requiredFlag = true;

        this.props.focusActions.triggerValidations(true);

        let fieldsWithError = '';
        let j = 0;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        if (!disabled) {
            const accountId = userProfile.accountType ? userProfile.accountType : 0;
            if (accountId === 0) {
                formActions.setValidity('userProfile.accountType', { required: false });

                return;
            }

            const requiredFields = this.getRequiredFields();
            // Parse validations
            for (let i = 0; i < requiredFields.length; i++) {
                const field = userProfile[requiredFields[i]];
                const isVisible = checkIfInputIsVisibleByPartialId(requiredFields[i]);

                if (!field) {
                    if (j == 0) {
                        fieldsWithError += requiredFields[i];
                    } else {
                        fieldsWithError += `|${requiredFields[i]}`;
                    }
                    j++;
                    isVisible && formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: false });
                    requiredFlag = false;
                }
            }

            this.validateComboList({ basicCombo: this.formValidations.capitalCombo });
            this.validateComboList({ basicCombo: this.formValidations.incomeCombo });

            const { basicCombo, flagDependency } = this.formValidations.accountUseCombo;
            this.validateComboList({
                flagDependency,
                basicCombo,
                flag: NEW_OPTIONS_OPERATIONS,
            });
        }

        if (!requiredFlag) {
            doTagErrorValidateFields({ investmentType, fieldsWithError });
        }

        return requiredFlag;
    }

    fillCapital() {
        const { userProfile } = this.props;
        const capital = {
            work: typeof userProfile['capital_work'] !== 'undefined' ? userProfile['capital_work'] : false,
            activities:
                typeof userProfile['capital_activities'] !== 'undefined' ? userProfile['capital_activities'] : false,
            heritage: typeof userProfile['capital_heritage'] !== 'undefined' ? userProfile['capital_heritage'] : false,
            business: typeof userProfile['capital_business'] !== 'undefined' ? userProfile['capital_business'] : false,
            realState:
                typeof userProfile['capital_realState'] !== 'undefined' ? userProfile['capital_realState'] : false,
            gamesOfChance:
                typeof userProfile['capital_gamesOfChance'] !== 'undefined'
                    ? userProfile['capital_gamesOfChance']
                    : false,
            other:
                typeof userProfile['capital_description'] !== 'undefined' && userProfile['capital_description'] !== ''
                    ? userProfile['capital_description']
                    : null,
        };

        return capital;
    }

    fillIncomes() {
        const { userProfile } = this.props;

        const incomes = {
            work: typeof userProfile['income_work'] !== 'undefined' ? userProfile['income_work'] : false,
            activities:
                typeof userProfile['income_activities'] !== 'undefined' ? userProfile['income_activities'] : false,
            business: typeof userProfile['income_business'] !== 'undefined' ? userProfile['income_business'] : false,
            realState: typeof userProfile['income_realState'] !== 'undefined' ? userProfile['income_realState'] : false,
            other:
                typeof userProfile['income_description'] !== 'undefined' && userProfile['income_description'] !== ''
                    ? userProfile['income_description']
                    : null,
        };

        return incomes;
    }

    fillPublicCharges(profileModel) {
        const { userProfile } = this.props;
        const modelName = profileModel.split('.')[1];
        const details =
            typeof userProfile[`${modelName}_details`] !== 'undefined' && userProfile[`${modelName}_details`] !== ''
                ? userProfile[`${modelName}_details`]
                : null;
        const publicCharges = {
            answer: userProfile[modelName] === 'true',
            details,
        };

        return publicCharges;
    }

    fillOperations(used = true) {
        const { userProfile, flags } = this.props;
        const areNewOptionsEnable = flags.get(NEW_OPTIONS_OPERATIONS);
        let operations;

        if (used) {
            const oldOperations = {
                buyingSellingBearerPaymentMethods:
                    typeof userProfile['buyingSellingBearerPaymentMethods'] !== 'undefined'
                        ? userProfile['buyingSellingBearerPaymentMethods']
                        : false,
                frequentTravelChecksMovements:
                    typeof userProfile['frequentTravelChecksMovements'] !== 'undefined'
                        ? userProfile['frequentTravelChecksMovements']
                        : false,
            };

            const newOperations = {
                [BANK_AND_TRAVEL_CHECKS_MOVEMENTS]:
                    typeof userProfile[BANK_AND_TRAVEL_CHECKS_MOVEMENTS] !== 'undefined'
                        ? userProfile[BANK_AND_TRAVEL_CHECKS_MOVEMENTS]
                        : false,
                [CRYPTO_CURRENCY_MOVEMENTS]:
                    typeof userProfile[CRYPTO_CURRENCY_MOVEMENTS] !== 'undefined'
                        ? userProfile[CRYPTO_CURRENCY_MOVEMENTS]
                        : false,
            };

            operations = {
                highOperativeWithRiskCountries:
                    typeof userProfile['highOperativeWithRiskCountries'] !== 'undefined'
                        ? userProfile['highOperativeWithRiskCountries']
                        : false,
                deliveryOrCashWithdrawals:
                    typeof userProfile['deliveryOrCashWithdrawals'] !== 'undefined'
                        ? userProfile['deliveryOrCashWithdrawals']
                        : false,
                buyingAndSellingForeingBanknotes:
                    typeof userProfile['buyingAndSellingForeingBanknotes'] !== 'undefined'
                        ? userProfile['buyingAndSellingForeingBanknotes']
                        : false,
                paymentOrdersOrCollectionAbroad:
                    typeof userProfile['paymentOrdersOrCollectionAbroad'] !== 'undefined'
                        ? userProfile['paymentOrdersOrCollectionAbroad']
                        : false,
                foreingTradeOperations:
                    typeof userProfile['foreingTradeOperations'] !== 'undefined'
                        ? userProfile['foreingTradeOperations']
                        : false,
                noneOfTheAbove:
                    typeof userProfile['noneOfTheAbove'] !== 'undefined' ? userProfile['noneOfTheAbove'] : false,
                ...(areNewOptionsEnable ? newOperations : oldOperations),
            };
        } else {
            const oldOperations = {
                buyingSellingBearerPaymentMethods: false,
                frequentTravelChecksMovements: false,
            };

            const newOperations = {
                [BANK_AND_TRAVEL_CHECKS_MOVEMENTS]: false,
                [CRYPTO_CURRENCY_MOVEMENTS]: false,
            };

            operations = {
                highOperativeWithRiskCountries: false,
                deliveryOrCashWithdrawals: false,
                buyingAndSellingForeingBanknotes: false,
                paymentOrdersOrCollectionAbroad: false,
                foreingTradeOperations: false,
                noneOfTheAbove: false,
                ...(areNewOptionsEnable ? newOperations : oldOperations),
            };
        }

        return operations;
    }

    fillPurpose(profileModel) {
        const { userProfile } = this.props;
        const modelName = profileModel.split('.')[1];
        const name = userProfile[modelName];
        const purpose = { personal: false, other: false, professional: false };
        name && (purpose[name] = true);

        return purpose;
    }

    fillTaxation() {
        const { userProfile } = this.props;
        let limit;
        const taxation = {
            answer: userProfile.taxation,
            taxationDetails: [],
        };
        if (taxation.answer && userProfile.taxationCounter) {
            const content = [];
            let reasonResident, reasonCitizen;
            limit = userProfile.taxationCounter ? Object.keys(userProfile.taxationCounter).length : 0;
            for (let i = 0; i < limit; i++) {
                switch (userProfile[`taxation_reason_${userProfile.taxationCounter[i]}`]) {
                    case 'RE':
                        reasonResident = true;
                        reasonCitizen = false;
                        break;
                    case 'CI':
                        reasonResident = false;
                        reasonCitizen = true;
                        break;
                    case 'AM':
                        reasonResident = true;
                        reasonCitizen = true;
                        break;
                    default:
                        reasonResident = false;
                        reasonCitizen = false;
                        break;
                }
                if (userProfile[`taxation_country_${userProfile.taxationCounter[i]}`]) {
                    content.push({
                        country: userProfile[`taxation_country_${userProfile.taxationCounter[i]}`],
                        citizenship: reasonCitizen,
                        residency: reasonResident,
                        tin: userProfile[`taxation_tin_code_${userProfile.taxationCounter[i]}`],
                    });
                }
                taxation.taxationDetails = content;
            }
            taxation.taxationDetails = content;
        }

        return taxation;
    }

    fillAnnualIncomeData = data => {
        const { userProfile } = this.props;

        const TRUE_RADIO = '1';

        const {
            userProfile: {
                monthlyRenting,
                monthlyLoan,
                monthlyMortgage,
                monthlyLoanAmount,
                monthlyMortgageAmount,
                monthlyRentingAmount,
                cirbeConsent,
            },
        } = this.props;

        const acceptedRenting = monthlyRenting === TRUE_RADIO;
        const acceptedMortgage = monthlyMortgage === TRUE_RADIO;
        const acceptedLoan = monthlyLoan === TRUE_RADIO;

        data['monthlyRenting'] = { answered: acceptedRenting, amount: acceptedRenting ? monthlyRentingAmount : '0' };
        data['monthlyMortgage'] = {
            answered: acceptedMortgage,
            amount: acceptedMortgage ? monthlyMortgageAmount : '0',
        };
        data['monthlyLoan'] = { answered: acceptedLoan, amount: acceptedLoan ? monthlyLoanAmount : '0' };
        data['cirbeConsent'] = cirbeConsent;
        data['monthlyAmount'] = parseInt(userProfile.monthlyAmount, 10);

        return data;
    };

    saveSelfEmployed(callback) {
        const { doTagErrorSaveSelfEmployed } = this.tagging;
        const { userProfile, flags } = this.props;
        const accessToken = userProfile.accessToken;
        let data = {};
        const profession = {
            option: userProfile['profession_cnae_answer'],
            subcategory: userProfile['profession_id'],
            id: userProfile['profession_category'],
        };
        let operations;

        data['profession'] = profession;
        data['companyName'] = userProfile.selfEmployed_company;
        data['capital'] = this.fillCapital();
        data['income'] = this.fillIncomes();
        data['annualIncomeAmount'] = userProfile.selfEmployed_annualIncomeAmount;
        data['publicCharges'] = this.fillPublicCharges('userProfile.selfEmployed_publicCharges');
        data['thirdParty'] = userProfile.selfEmployed_accountMoney;
        data['purpose'] = this.fillPurpose('userProfile.selfEmployed_accountUse');

        if (userProfile.selfEmployed_accountUse !== 'personal') {
            operations = this.fillOperations();
        } else {
            operations = this.fillOperations(false);
        }

        data['operations'] = operations;
        data['taxation'] = this.fillTaxation();

        if (flags.get(CIRBE) && userProfile.investmentType === CREDIT_CARD)
            data = { ...data, ...this.fillAnnualIncomeData(data) };

        return this.props.accountTypeActions.saveSelfEmployedInformation(data, accessToken, (saved, error) => {
            if (saved) {
                callback();
            } else {
                doTagErrorSaveSelfEmployed(error);
                history.push(`${BASE_PATH}/errors`);
            }
        });
    }

    saveEmployed(callback) {
        const { userProfile, flags } = this.props;
        const { doTagErrorSaveEmployed } = this.tagging;
        const accessToken = userProfile.accessToken;
        let data = {};
        let idProfession;

        if (userProfile['cno1_profession_id'] && userProfile['cno1_profession_id'] !== '-1') {
            idProfession = userProfile['cno1_profession_id'];
        }
        if (userProfile['cno2_profession_id'] && userProfile['cno2_profession_id'] !== '-1') {
            idProfession = userProfile['cno2_profession_id'];
        }

        const profession = {
            option: userProfile['profession_option'],
            subcategory: userProfile['profession_category'],
            id: idProfession,
        };
        let operations;

        data['profession'] = profession;
        data['companyName'] = userProfile.employed_company;
        data['capital'] = this.fillCapital();
        data['income'] = this.fillIncomes();
        data['annualIncomeAmount'] = userProfile.employed_annualIncomeAmount;
        data['publicCharges'] = this.fillPublicCharges('userProfile.employed_hasPEP');
        data['thirdParty'] = userProfile.employed_accountMoney;
        data['purpose'] = this.fillPurpose('userProfile.employed_accountUse');

        if (userProfile.employed_accountUse !== 'personal') {
            operations = this.fillOperations();
        } else {
            operations = this.fillOperations(false);
        }

        data['operations'] = operations;
        data['taxation'] = this.fillTaxation();
        if (flags.get(CIRBE) && userProfile.investmentType === CREDIT_CARD)
            data = { ...data, ...this.fillAnnualIncomeData(data) };

        return this.props.accountTypeActions.saveEmployedInformation(data, accessToken, (saved, error) => {
            if (saved) {
                callback();
            } else {
                doTagErrorSaveEmployed(error);
                history.push(`${BASE_PATH}/errors`);
            }
        });
    }

    saveRentier(callback) {
        const { doTagErrorSaveRentier } = this.tagging;
        const { userProfile, flags } = this.props;
        const accessToken = userProfile.accessToken;
        let data = {};
        let operations;

        data['capital'] = this.fillCapital();
        data['income'] = this.fillIncomes();
        data['annualIncomeAmount'] = userProfile.rentier_annualIncomeAmount;
        data['publicCharges'] = this.fillPublicCharges('userProfile.rentier_hasPEP');
        data['thirdParty'] = userProfile.rentier_accountMoney;
        data['purpose'] = this.fillPurpose('userProfile.rentier_accountUse');

        if (userProfile.rentier_accountUse !== 'personal') {
            operations = this.fillOperations();
        } else {
            operations = this.fillOperations(false);
        }

        data['operations'] = operations;
        data['taxation'] = this.fillTaxation();
        if (flags.get(CIRBE) && userProfile.investmentType === CREDIT_CARD)
            data = { ...data, ...this.fillAnnualIncomeData(data) };

        return this.props.accountTypeActions.saveRentierInformation(data, accessToken, (saved, error) => {
            if (saved) {
                callback();
            } else {
                doTagErrorSaveRentier(error);
                history.push(`${BASE_PATH}/errors`);
            }
        });
    }

    savePensioner(callback) {
        const { userProfile, flags } = this.props;
        const { doTagErrorSavePensioner } = this.tagging;
        const accessToken = userProfile.accessToken;
        let data = {};
        let operations;

        data['capital'] = this.fillCapital();
        data['income'] = this.fillIncomes();
        data['annualIncomeAmount'] = userProfile.pensioner_annualIncomeAmount;
        data['publicCharges'] = this.fillPublicCharges('userProfile.pensioner_hasPEP');
        data['thirdParty'] = userProfile.pensioner_accountMoney;
        data['purpose'] = this.fillPurpose('userProfile.pensioner_accountUse');

        if (userProfile.pensioner_accountUse !== 'personal') {
            operations = this.fillOperations();
        } else {
            operations = this.fillOperations(false);
        }

        data['operations'] = operations;
        data['taxation'] = this.fillTaxation();
        if (flags.get(CIRBE) && userProfile.investmentType === CREDIT_CARD)
            data = { ...data, ...this.fillAnnualIncomeData(data) };

        return this.props.accountTypeActions.savePensionerInformation(data, accessToken, (saved, error) => {
            if (saved) {
                callback();
            } else {
                doTagErrorSavePensioner(error);
                history.push(`${BASE_PATH}/errors`);
            }
        });
    }

    saveWithoutActivity(callback) {
        const { userProfile, flags } = this.props;
        const { doTagErrorSaveWithoutActivity } = this.tagging;
        const accessToken = userProfile.accessToken;
        const data = {};
        let operations;

        data['profession'] = userProfile.withoutActivity_activity;
        data['capital'] = this.fillCapital();
        data['publicCharges'] = this.fillPublicCharges('userProfile.withoutActivity_hasPEP');
        data['thirdParty'] = userProfile.withoutActivity_accountMoney;
        data['purpose'] = this.fillPurpose('userProfile.withoutActivity_accountUse');

        if (userProfile.withoutActivity_accountUse !== 'personal') {
            operations = this.fillOperations();
        } else {
            operations = this.fillOperations(false);
        }

        data['operations'] = operations;
        data['taxation'] = this.fillTaxation();

        if (flags.get(ONBOARDING_FLAG_WEB_FIOC_RESPONSE_NO_ACT)) {
            data['fundsOrigins'] = getFundsOriginsCheckedStatus(userProfile);
        }

        return this.props.accountTypeActions.saveUnemployedInformation(data, accessToken, (saved, error) => {
            if (saved) {
                callback();
            } else {
                doTagErrorSaveWithoutActivity(error);
                history.push(`${BASE_PATH}/errors`);
            }
        });
    }

    saveFiocData(callback) {
        const { userProfile } = this.props;
        const accountId = userProfile.accountType;
        let saved;

        switch (accountId) {
            case '01':
                saved = this.saveSelfEmployed;
                break;
            case '02':
                saved = this.saveEmployed;
                break;
            case '03':
                saved = this.saveRentier;
                break;
            case '04':
                saved = this.savePensioner;
                break;
            case '05':
                saved = this.saveWithoutActivity;
                break;
            default:
                break;
        }

        return saved(callback);
    }

    clientFiocAlta() {
        const { userProfile, preLoaderActions } = this.props;
        this.props.actions.clientFiocAlta(userProfile.accessToken, (verifiedOk, errors) => {
            preLoaderActions.hidePreLoader();
            if (verifiedOk) {
                this.gotoNextStep();
            } else {
                if (errors['6002']) {
                    history.push(`${BASE_PATH}/errors`);
                }
                this.setState({ isClicked: false });
            }
        });
    }

    createClient() {
        const {
            userProfile,
            actions,
            createActions,
            immStepsState,
            preLoaderActions,
            formActions,
            disableSpainCardSelection,
            consentsActions,
        } = this.props;
        const { doTagCreateClient } = this.tagging;
        const accessToken = userProfile.accessToken;
        const currentIndex = immStepsState.get('currentStep');
        const finishAction = () => {
            if (mustContinueToStep3(userProfile, disableSpainCardSelection)) {
                actions.finalizeStep({
                    index: currentIndex,
                    finished: true,
                });

                actions.enableFinishedAndNextStep();
                actions.changeCurrentStep({
                    index: currentIndex + 1,
                });
            } else {
                formActions.change('userProfile.status', DEBIT_CARD);
            }
            preLoaderActions.hidePreLoader();
        };
        const onCreateClient = userId => {
            doTagCreateClient(userId);
        };
        createClientWithConsent({ createActions, consentsActions }, accessToken, onCreateClient, finishAction);
    }

    gotoNextStep() {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = this.props.immStepsState.get('readOnlyForms');
        if (!disabled) {
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    }

    setJaffarLimit() {
        const { userProfile, scoringActions } = this.props;
        const limit = userProfile.accountType === '02' || userProfile.accountType === '04' ? 600 : 300;
        const data = {
            status: 'OK',
            cardLimit: limit,
            scoringStatus: 'approved',
            scoringType: 'jaffar',
        };
        scoringActions.setScoringJaffar(data);
    }

    handleSubmit() {
        const {
            userProfileForm,
            userProfile,
            preLoaderActions,
            jointHoldersStatusActions,
            immStepsState,
            formActions,
            scorings,
            scoringActions,
            jointHoldersActions,
            flags,
        } = this.props;
        const { doTagSubmit, doTagErrorSaveFiocVerify } = this.tagging;
        const accessToken = userProfile.accessToken;
        const disabled = immStepsState.get('readOnlyForms');
        const currentIndex = immStepsState.get('currentStep');
        const openCredit = userProfile.creditCardOffer_accepted;
        const ml2 = scorings.getIn(['ml2', 'scoringStatus']) === 'approved';
        const openCreditJaffar = userProfile.openCreditJaffar;
        const isFiocTgssFlagActive = flags.get(FIOC_TGSS);

        if (!disabled) {
            if (userProfileForm.$form.valid) {
                preLoaderActions.setInformationText(formatText('informationText-fioc'));
                preLoaderActions.showPreLoader();

                this.saveFiocData(() => {
                    doTagSubmit(userProfile.accountType, {
                        isTssChecked: !!userProfile.fiocTgssConsent,
                        profession: userProfile.withoutActivity_activity,
                    });
                    if (openCredit || openCreditJaffar) {
                        scoringActions.postJaffar(userProfile.accessToken, (valid, data) => {
                            if (!valid || !data.cardLimit) {
                                scoringActions.getLimitJaffar(userProfile.accessToken, valid => {
                                    if (!valid) {
                                        this.setJaffarLimit();
                                    }
                                    if (!ml2) {
                                        formActions.change('userProfile.showOpenCredit', true);
                                    }
                                });
                            } else if (!ml2) {
                                formActions.change('userProfile.showOpenCredit', true);
                            }
                        });

                        if (ml2) {
                            this.props.actions.clientFiocVerify(accessToken, (verified, data) => {
                                if (verified) {
                                    if (userProfile.investmentType === ROBO || userProfile.investmentType === GBI) {
                                        this.clientFiocAlta();
                                    } else {
                                        this.createClient();
                                    }
                                } else {
                                    if (data['0301']) {
                                        this.props.actions.changeMinFinalizeStep({ index: 0 });
                                        this.props.actions.finalizeStep({
                                            index: currentIndex,
                                            finished: true,
                                        });
                                        jointHoldersStatusActions.statusHolders(accessToken);
                                        formActions.change('userProfile.status', 'waiting');
                                    } else {
                                        this.handleShowNonExclusiveModal();
                                    }
                                    preLoaderActions.hidePreLoader();
                                }
                            });
                        }
                    } else {
                        this.props.actions.clientFiocVerify(accessToken, (verified, data) => {
                            if (verified) {
                                if (userProfile.investmentType === ROBO || userProfile.investmentType === GBI) {
                                    this.clientFiocAlta();
                                } else {
                                    this.createClient();
                                }
                            } else {
                                doTagErrorSaveFiocVerify(data);
                                if (data['0301']) {
                                    this.props.actions.changeMinFinalizeStep({ index: 0 });
                                    this.props.actions.finalizeStep({
                                        index: currentIndex,
                                        finished: true,
                                    });

                                    const finishAction = () => {
                                        formActions.change('userProfile.status', 'waiting');
                                        preLoaderActions.hidePreLoader();
                                    };

                                    jointHoldersStatusActions.statusHolders(accessToken);
                                    isFiocTgssFlagActive
                                        ? jointHoldersActions.sendJointHolderTgssInfo(accessToken, finishAction)
                                        : finishAction();
                                } else {
                                    this.handleShowNonExclusiveModal();
                                    preLoaderActions.hidePreLoader();
                                }
                            }
                        });
                    }
                });
            }
        } else {
            this.props.actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    }

    handleResetFields(accountType) {
        const { userProfile, formActions } = this.props;
        let employedFields = this.formValidations.employed.primaries;
        let selfEmployedFields = this.formValidations.selfEmployed.primaries;
        let rentier = this.formValidations.rentier.primaries;
        let pensioner = this.formValidations.pensioner.primaries;
        let withoutActivity = this.formValidations.withoutActivity.primaries;
        const accountId = accountType ? accountType : 0;
        let field;
        let fieldsToReset = [];

        let reset = true;
        if (accountType === userProfile.accountType) {
            reset = false;
        }

        if (reset) {
            if (accountId === '01') {
                selfEmployedFields = selfEmployedFields.concat(['selfEmployed_company']);
                selfEmployedFields = selfEmployedFields.concat(['profession_cnae_answer']);
                selfEmployedFields = selfEmployedFields.concat(['profession_category']);
                selfEmployedFields = selfEmployedFields.concat(['profession_id']);
                selfEmployedFields = selfEmployedFields.concat(
                    this.formValidations.selfEmployed.dependences.selfEmployed_hasPEP
                );
                selfEmployedFields = selfEmployedFields.concat(
                    this.formValidations.selfEmployed.dependences.selfEmployed_accountMoney
                );
                selfEmployedFields = selfEmployedFields.concat(
                    this.formValidations.selfEmployed.dependences.selfEmployed_accountUse
                );
                selfEmployedFields = selfEmployedFields.concat(
                    this.formValidations.selfEmployed.dependences.selfEmployed_usage
                );
                fieldsToReset = selfEmployedFields;
            }

            if (accountId === '02') {
                employedFields = employedFields.concat(['employed_company']);
                employedFields = employedFields.concat(['profession_option']);
                employedFields = employedFields.concat(['profession_category']);
                employedFields = employedFields.concat(['cno1_profession_id']);
                employedFields = employedFields.concat(['cno2_profession_id']);
                employedFields = employedFields.concat(this.formValidations.employed.dependences.employed_hasPEP);
                employedFields = employedFields.concat(this.formValidations.employed.dependences.employed_usage);
                employedFields = employedFields.concat(this.formValidations.employed.dependences.employed_accountMoney);
                employedFields = employedFields.concat(this.formValidations.employed.dependences.employed_accountUse);
                fieldsToReset = employedFields;
            }

            if (accountId === '03') {
                rentier = rentier.concat(this.formValidations.rentier.dependences.rentier_hasPEP);
                fieldsToReset = rentier;
            }

            if (accountId === '04') {
                pensioner = pensioner.concat(this.formValidations.pensioner.dependences.pensioner_hasPEP);
                pensioner = pensioner.concat(this.formValidations.pensioner.dependences.pensioner_usage);
                fieldsToReset = pensioner;
            }

            if (accountId === '05') {
                withoutActivity = withoutActivity.concat(
                    this.formValidations.withoutActivity.dependences.withoutActivity_hasPEP
                );
                withoutActivity = withoutActivity.concat(
                    this.formValidations.withoutActivity.dependences.withoutActivity_usage
                );
                fieldsToReset = withoutActivity;
            }

            const capital = [
                'capital_work',
                'capital_activities',
                'capital_heritage',
                'capital_business',
                'capital_realState',
                'capital_gamesOfChance',
                'capital_other',
                'capital_description',
            ];
            const fundsOrigin = Object.values(FUNDS_ORIGINS_USER_PROFILE_KEYS);

            const income = [
                'income_work',
                'income_activities',
                'income_business',
                'income_realState',
                'income_other',
                'income_description',
            ];

            const operations = [
                'highOperativeWithRiskCountries',
                'buyingSellingBearerPaymentMethods',
                'frequentTravelChecksMovements',
                'deliveryOrCashWithdrawals',
                'buyingAndSellingForeingBanknotes',
                'paymentOrdersOrCollectionAbroad',
                'foreingTradeOperations',
                'noneOfTheAbove',
                CRYPTO_CURRENCY_MOVEMENTS,
                BANK_AND_TRAVEL_CHECKS_MOVEMENTS,
            ];

            const taxationQuestions = [
                'taxation_country_1',
                'taxation_country_2',
                'taxation_country_3',
                'taxation_country_4',
                'taxation_reason_1',
                'taxation_reason_2',
                'taxation_reason_3',
                'taxation_reason_4',
                'taxation_tin_code_1',
                'taxation_tin_code_2',
                'taxation_tin_code_3',
                'taxation_tin_code_4',
                'taxation',
                'taxationCounter',
            ];

            const annualIncomeQuestions = ['monthlyRenting', 'monthlyMortgage', 'monthlyLoan', 'cirbeConsentCheck'];

            fieldsToReset = fieldsToReset.concat(capital);
            fieldsToReset = fieldsToReset.concat(fundsOrigin);
            fieldsToReset = fieldsToReset.concat(income);
            fieldsToReset = fieldsToReset.concat(annualIncomeQuestions);
            fieldsToReset = fieldsToReset.concat(operations);
            fieldsToReset = fieldsToReset.concat(taxationQuestions);
            for (let i = 0; i < fieldsToReset.length; i++) {
                field = fieldsToReset[i];
                if (typeof userProfile[field] !== 'undefined') {
                    formActions.change(`userProfile.${field}`);
                }
            }
        }
    }

    buildModalNonExclusiveKO() {
        const modalClass = `timeout-modal overwritten-modal ${this.state.blowupClass}`;

        return (
            <div>
                <Modal
                    {...this.props}
                    show={this.state.showModalNonExclusiveKO}
                    dialogClassName={modalClass}
                    backdrop="static"
                    keyboard={false}
                    animation={false}
                >
                    <Modal.Body>
                        <h3 className="font-heading3">{formatText('boxes-passErrorFiocTitle')}</h3>
                        <div className="icon-container expired-Message">
                            <p className="font-paragraph2">{formatText('boxes-passErrorFiocDescription')}</p>
                        </div>
                        <div className="form__buttons">
                            <button className="form__button form__button-secondary" onClick={this.handleBlowupClass}>
                                {formatText('button-understood')}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    handleShowNonExclusiveModal() {
        this.setState({ showModalNonExclusiveKO: true, blowupClass: 'blowup-modal blowup-in' });
    }

    handleBlowupClass() {
        this.setState({ blowupClass: 'blowup-modal blowup-out' });
        setTimeout(() => {
            this.handleHideNonExclusiveModal();
        }, 200);
    }

    handleHideNonExclusiveModal() {
        this.setState({ showModalNonExclusiveKO: false });
    }

    isButtonContinueEnabled = () => {
        const { userProfile, flags, userProfileForm } = this.props;
        const isCreditCardFlow = userProfile.investmentType === CREDIT_CARD;
        switch (userProfile.accountType) {
            case '01':
            case '02':
            case '03':
            case '04':
                if (isCreditCardFlow) {
                    return flags.get(CIRBE)
                        ? userProfile.cirbeConsent
                        : !!userProfile[`${accountTypeModel[userProfile.accountType]}_annualIncomeAmount`];
                }

                const taxationCountryKey = 'taxation_country';
                const taxationTinCodeKey = 'taxation_tin_code';
                const taxationReasonKey = 'taxation_reason';
                const isTaxationQuestionAsked = !!userProfile.taxation;
                const isTaxationQuestionYes = userProfile.taxation === 'true';

                const isTaxationDataFilledAndValid = () =>
                    !userProfile.validatingTin &&
                    userProfile.taxationCounter?.every(taxationIndex => {
                        const taxationCountryWithIndex = `${taxationCountryKey}_${taxationIndex}`;
                        const taxationTinCodeWithIndex = `${taxationTinCodeKey}_${taxationIndex}`;
                        const taxationReasonWithIndex = `${taxationReasonKey}_${taxationIndex}`;

                        const taxationCountry = userProfileForm[taxationCountryWithIndex];
                        const taxationTinCode = userProfileForm[taxationTinCodeWithIndex];
                        const taxationReason = userProfileForm[taxationReasonWithIndex];

                        const fieldsToValidate = [taxationCountry, taxationTinCode, taxationReason];

                        return fieldsToValidate.every(field => field?.value && field?.valid);
                    });

                return isTaxationQuestionYes ? isTaxationDataFilledAndValid() : isTaxationQuestionAsked;
            case '05':
                if (isCreditCardFlow) return !!userProfile[`${accountTypeModel[userProfile.accountType]}_activity`];

                return !!userProfile.taxation;
            default:
                break;
        }
    };

    handleChangeFieldWorkBy(value) {
        const { doTagChangeFieldWorkBy } = this.tagging;
        this.props.formActions.resetValidity('userProfile');
        doTagChangeFieldWorkBy(value);
        this.handleResetFields(value);
    }

    buildForm() {
        const { userProfile } = this.props;
        const { investmentType } = userProfile;
        const accountId = userProfile.accountType ? userProfile.accountType : '';
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const accountView = <AccountType typeId={accountId} disabled={disabled} {...this.props} />;
        const modalNonExclusive = this.buildModalNonExclusiveKO();

        const wizardDescriptionByInvestmentType =
            investmentType === CREDIT_CARD
                ? formatText('stepsTitles-professionalDataDescriptionCreditCard')
                : formatText('stepsTitles-professionalDataDescription');
        const wizardDisclaimerByInvestmentType =
            investmentType === CREDIT_CARD
                ? formatText('stepsTitles-professionalDataDisclaimerCreditCard')
                : formatText('stepsTitles-professionalDataDisclaimer');

        return (
            <div>
                <Headline icon="fioc" className="prospects-gutter">
                    <h2>{formatText('stepsTitles-professionalDataTitle')}</h2>
                    <p>{wizardDescriptionByInvestmentType}</p>
                </Headline>
                <div className="account-steps profile-step-2">
                    <Form model="userProfile" onSubmit={this.handleSubmit} className="form" name="form">
                        <div className="prospects-gutter prospects-separator">
                            {modalNonExclusive}
                            <Disclaimer>
                                <label>{wizardDisclaimerByInvestmentType}</label>
                            </Disclaimer>
                            <div className="row md-form-group">
                                <div className="col-sm-8">
                                    <RadioButton
                                        profileModel="userProfile.accountType"
                                        label={formatText('field-workBy')}
                                        optionsList={this.getWorkFor()}
                                        onChange={this.handleChangeFieldWorkBy}
                                        disabled={disabled}
                                        focusAnimated
                                        {...this.props}
                                    />
                                </div>
                            </div>
                            {accountView}
                        </div>
                        <div className="form__footer">
                            <RoadmapNavigation
                                buttonPrevHidden
                                buttonCancelAction={this.handleCancel}
                                buttonContinueType="submit"
                                buttonContinueAction={this.onHandleValidateFields}
                                buttonContinueDisabled={false}
                                buttonContinueFakeDisabled={!this.isButtonContinueEnabled()}
                            />
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

    render() {
        const { userProfile, immJointHoldersStatus } = this.props;
        let block;
        if (userProfile.status === 'waiting' && immJointHoldersStatus.get('fetchSuccess')) {
            block = <StandByHC />;
            window.scrollTo(0, 0);
        } else if (userProfile.status !== 'waiting') {
            block = this.buildForm();
        }

        return <div>{block}</div>;
    }
}

ProfileStep2.propTypes = {
    options: PropTypes.object.isRequired,
    optionsActions: PropTypes.object.isRequired,
    userProfile: PropTypes.object.isRequired,
    userProfileForm: PropTypes.object.isRequired,
    immStepsState: PropTypes.object.isRequired,
    extraData: PropTypes.object.isRequired,
    focus: PropTypes.object.isRequired,
    immJointHoldersStatus: PropTypes.object.isRequired,
    scorings: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    formActions: PropTypes.object.isRequired,
    focusActions: PropTypes.object.isRequired,
    standByActions: PropTypes.object.isRequired,
    createActions: PropTypes.object.isRequired,
    preLoaderActions: PropTypes.object.isRequired,
    accountTypeActions: PropTypes.object.isRequired,
    jointHoldersStatusActions: PropTypes.object.isRequired,
    scoringActions: PropTypes.object.isRequired,
    flags: PropTypes.object.isRequired,
    disableSpainCardSelection: PropTypes.object,
    modalCancelActions: PropTypes.object.isRequired,
    consentsActions: PropTypes.object.isRequired,
    jointHoldersActions: PropTypes.object.isRequired,
};

module.exports.constructor = ProfileStep2;
module.exports.ProfileStep2 = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        extraData: state.extraData,
        options: state.options,
        focus: state.focus,
        immJointHoldersStatus: state.jointHoldersStatus,
        scorings: state.scorings,
        immManagementPlan: state.raManagementPlan,
        immSimulation: state.raSimulation,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        products: state.products,
        disableSpainCardSelection: state.featureFlagging.getIn(['data', 'disableSpainCardSelection']),
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        scoringActions: bindActionCreators(scoringActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
    })
)(withFeatureToggling(ProfileStep2));
